import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { useTranslation } from 'react-i18next'
import Heading from 'components/Luxkit/Typography/Heading'
import Caption from 'components/Luxkit/Typography/Caption'
import Group from 'components/utils/Group'
import Label from 'components/Luxkit/Label/Label'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'
import Divider from 'components/Luxkit/Divider'

const BorderedContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.neutral.five};
  border-bottom: 0;
  padding: ${rem(24)} ${rem(16)} 0;
  min-width: ${rem(320)};
`

const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`
interface Props {
  pkg: App.Package;
  hasMoreInclusions?: boolean;
  isUpgrade?: boolean;
  isDifferentRoom?: boolean;
}

function LePackageUpgradeColumnHeader({
  pkg,
  hasMoreInclusions,
  isUpgrade,
  isDifferentRoom,
}: Props) {
  const { t } = useTranslation('offerPage')

  const { roomType } = pkg

  return (
    <BorderedContainer>
      <Group direction="vertical" gap={8} fullHeight>
        {(!isUpgrade || isDifferentRoom || hasMoreInclusions) && (
          <LabelGroup>
            {!isUpgrade && <Label kind="secondary" variant="grey">{t('Your package', { ns: 'offerPage' })}</Label>}
            {isDifferentRoom && <Label kind="tertiary" variant="highlight">{t('Upgraded room', { ns: 'offerPage' })}</Label>}
            {hasMoreInclusions && <Label kind="tertiary" variant="highlight">{t('More inclusions', { ns: 'offerPage' })}</Label>}
          </LabelGroup>
        )}
        <TitleGroup>
          <Heading variant="heading6" colour="neutral-one">{pkg.name}</Heading>
          <Caption colour="neutral-three" variant="medium">{roomType?.name}</Caption>
        </TitleGroup>
        <Divider kind="primary" />
      </Group>
    </BorderedContainer>
  )
}

export default LePackageUpgradeColumnHeader
